import { COPY_WORKOUT, DELETE_WORKOUT, FETCH_WORKOUT_BY_ID, UPLOAD_AUDIO_NOTE, DELETE_AUDIO_NOTE } from './ActionTypes';

export function fetchWorkoutById(fullLocale, workoutId, savedWorkout, includeAudioNotes, viewerSocialProfile) {
    return {
        type: FETCH_WORKOUT_BY_ID,
        payload: { fullLocale, workoutId, savedWorkout, includeAudioNotes, viewerSocialProfile }
    };
}

export function copyWorkout(workoutId, workoutName, callback) {
    return {
        type: COPY_WORKOUT,
        workoutId,
        workoutName,
        callback
    };
}

export function deleteWorkout(workoutId, callback) {
    return {
        type: DELETE_WORKOUT,
        workoutId,
        callback
    };
}

export function uploadAudioNote(audioBlob, callback) {
    return {
        type: UPLOAD_AUDIO_NOTE,
        audioBlob,
        callback
    };
}

export function deleteAudioNote(audioUuid, callback) {
    return {
        type: DELETE_AUDIO_NOTE,
        audioUuid,
        callback
    };
}
